export function sendObjectFileManager(data) {
  return {
    type: 'OBJECT-FILE-MANAGER',
    data,
  };
}
